import {get} from 'lodash-es';

const storeKey = 'v2.services.objects.eventRecords';

/**
 * @param {Object} state
 * @param {String} name
 * @returns {Array.object}
 */
export const getEventRecordsByName = (state, name) => get(state, `${storeKey}.${name}.items`, []);

/**
 * @param {Object} state
 * @returns {String}
 */
export const getError = (state, name) => get(state, `${storeKey}.${name}.error`, null);

/**
 *
 * @param {Object} state
 * @param {String} name
 * @returns {Boolean}
 */
export const getIsLoading = (state, name) => get(state, `${storeKey}.${name}.isLoading`, false);
